import { toast } from '@grandvisionhq/common';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import { getWishlistButtonEventInfo, pushWishlistEvent } from '../data-layer/wishlist.js';
import { useAddToShoppingList } from './use-add-to-shopping-list.js';
import { useRemoveFromShoppinglist } from './use-remove-from-shopping-list.js';
import { useWishlistAuthState } from './use-wishlist-auth-state.js';

const useWishlistActions = (wishlistLocation)=>{
    const { isUserLoggedIn  } = useWishlistAuthState();
    const { clearWishlist  } = useWishlistId();
    const { addToShoppinglist  } = useAddToShoppingList({
        isLoggedIn: isUserLoggedIn,
        onCompleted: (data)=>{
            // If the mutation "succeeds", the BE can technically still send back a failure in the response
            // and a 200. This is why we need to check if the shoppinglist is actually there.
            // In case of a failure the shoppinglist will be null.
            if (data.addToShoppinglist.__typename === 'AddToShoppinglistSuccessResponse') {
                toast.success('account.wishlist.add.success');
                const { interactionType , siteFeature  } = getWishlistButtonEventInfo('add', wishlistLocation);
                pushWishlistEvent({
                    siteFeature,
                    interactionType,
                    messageType: 'item_added',
                    item: {
                        sku: data.addToShoppinglist.result.id
                    }
                });
            }
        },
        onError: (productSkus)=>{
            toast.failed('account.wishlist.add.error');
            const { interactionType , siteFeature  } = getWishlistButtonEventInfo('add', wishlistLocation);
            var ref;
            pushWishlistEvent({
                siteFeature,
                interactionType,
                messageType: 'error',
                item: {
                    sku: (ref = productSkus[0]) !== null && ref !== void 0 ? ref : ''
                }
            });
        }
    });
    const { removeFromShoppinglist  } = useRemoveFromShoppinglist({
        onCompleted: (data)=>{
            var ref;
            // If the mutation "succeeds", the BE can technically still send back a failure in the response
            // and a 200. This is why we need to check if the shoppinglist is actually there.
            // In case of a failure the shoppinglist will be null.
            if (data.removeFromShoppinglist.__typename == 'RemoveFromShoppinglistSuccessResponse') {
                var ref1;
                toast.success('account.wishlist.remove.success');
                const { interactionType , siteFeature  } = getWishlistButtonEventInfo('remove', wishlistLocation);
                var ref2;
                pushWishlistEvent({
                    siteFeature,
                    interactionType,
                    messageType: 'item_removed',
                    item: {
                        sku: (ref2 = (ref1 = data.removeFromShoppinglist.result) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : ''
                    }
                });
            }
            /*
        If the wishlist is empty after removing an item (i.e. mutating the list),
        we need to remove the list from local storage to prevent modifying an empty
        list with the same id.
      */ if (data.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistSuccessResponse' && !((ref = data.removeFromShoppinglist.result) === null || ref === void 0 ? void 0 : ref.items.length)) {
                clearWishlist();
            }
        },
        onError: (productSkus)=>{
            toast.failed('account.wishlist.remove.error');
            const { interactionType , siteFeature  } = getWishlistButtonEventInfo('remove', wishlistLocation);
            var ref;
            pushWishlistEvent({
                siteFeature,
                interactionType,
                messageType: 'error',
                item: {
                    sku: (ref = productSkus[0]) !== null && ref !== void 0 ? ref : ''
                }
            });
        }
    });
    return {
        addToShoppinglist,
        removeFromShoppinglist
    };
};

export { useWishlistActions };
//# sourceMappingURL=use-wishlist-actions.js.map
